import React from 'react';
import SEOLandingPage from '../SEOLandingPage';
import { UserX, TrendingUp, DollarSign, Globe } from 'lucide-react';

const FacelessVideoGeneratorPage: React.FC = () => {
  return (
    <SEOLandingPage 
      title="Faceless Video Generator"
      description="Build a profitable faceless YouTube channel with AI-powered physics videos. Our faceless content creator tool is the easiest way to generate viral shorts and reels."
      keywords="faceless video generator, faceless YouTube ideas, AI video generator, faceless shorts, automated channel tools, viral content engine, fun circle games, funcirclegames, fun circle games creator studio"
      heroTitle="Automated Faceless Content Engine"
      heroSubtitle="Launch and scale your social media empire without ever showing your face. Use satisfying ball simulations to drive massive engagement and revenue."
      features={[
        {
          title: "Privacy Focused",
          description: "Build a global brand and audience completely anonymously. No camera or setup required.",
          icon: <UserX className="w-6 h-6" />
        },
        {
          title: "Viral Niche Access",
          description: "Instantly tap into the 'Oddly Satisfying' niche, known for massive global reach and high retention.",
          icon: <Globe className="w-6 h-6" />
        },
        {
          title: "Scaleable Revenue",
          description: "One simulation can be exported in multiple formats to populate TikTok, Reels, and Shorts at once.",
          icon: <DollarSign className="w-6 h-6" />
        },
        {
          title: "Trend Ready",
          description: "Quickly adapt to trending music and visual styles within the Creator Studio workspace.",
          icon: <TrendingUp className="w-6 h-6" />
        }
      ]}
      contentSnippet="Faceless channels are the new gold rush on platforms like YouTube and TikTok. Our faceless video generator provides the exact high-quality assets needed to stand out in the crowded content landscape. By focusing on satisfying physics and ASMR, you can create a channel that attracts premium advertisers and a loyal, global following — all without ever stepping in front of a lens."
      currentTool="/faceless-video-generator"
    />
  );
};

export default FacelessVideoGeneratorPage;
